/**
 * Lucide Icons Configuration - Mente Bonita
 */

import {
  LucideAngularModule,
  House,
  User,
  Settings,
  Search,
  Mail,
  Bell,
  Calendar,
  Heart,
  Star,
  Download,
  Upload,
  Trash2,
  CircleCheck,
  CircleAlert,
  Info,
  TriangleAlert,
  Circle,
  ArrowRight,
  ArrowLeft,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  Menu,
  X,
  MessageCircle,
  MessageCircleQuestionMark,
  MessageSquare,
  Headphones,
  Plus,
  Phone,
  PhoneOff,
  Share2,
  Bookmark,
  CircleX,
  Check,
  SlidersHorizontal,
  Clock,
  Repeat,
  Mic,
  MicOff,
  Video,
  VideoOff,
  CreditCard,
  LogOut,
  ClipboardList,
  FileText,
  ExternalLink,
  Activity,
  BarChart3,
  Send,
  Sparkles,
  Trophy,
  Award,
  TrendingUp,
  TrendingDown,
  Compass,
  Lock,
  MonitorSpeaker,
  Monitor,
  EyeOff,
  Ellipsis,
  MapPin,
  Laptop,
  Building2,
  Users,
  BookOpen,
  Store,
  ClipboardCheck,
  FolderOpen,
} from 'lucide-angular';

export const LucideIconsModule = LucideAngularModule.pick({
  House,
  User,
  Settings,
  Search,
  Mail,
  Bell,
  Calendar,
  Heart,
  Star,
  Download,
  Upload,
  Trash2,
  CircleCheck,
  CircleAlert,
  Info,
  TriangleAlert,
  Circle,
  ArrowRight,
  ArrowLeft,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  Menu,
  X,
  MessageCircle,
  MessageCircleQuestionMark,
  MessageSquare,
  Headphones,
  Plus,
  Phone,
  PhoneOff,
  Share2,
  Bookmark,
  CircleX,
  Check,
  SlidersHorizontal,
  Clock,
  Repeat,
  Mic,
  MicOff,
  Video,
  VideoOff,
  CreditCard,
  LogOut,
  ClipboardList,
  FileText,
  ExternalLink,
  Activity,
  BarChart3,
  Send,
  Sparkles,
  Trophy,
  Award,
  TrendingUp,
  TrendingDown,
  Compass,
  Lock,
  MonitorSpeaker,
  Monitor,
  EyeOff,
  Ellipsis,
  MapPin,
  Laptop,
  Building2,
  Users,
  BookOpen,
  Store,
  ClipboardCheck,
  FolderOpen,
});
